module.exports = __webpack_public_path__ + "img/hint-four-eng.bb469464.jpg";